'use client';

import Link from 'next/link';
import type { FunctionComponent } from 'react';
import Markdown from 'react-markdown';

export const MarkdownParser: FunctionComponent<{ markdownString: string }> = ({ markdownString }) => {
  const classNames = 'font-bold not-italic text-dark dark:text-n700_text_dark_mode';
  const thinTextClassNames = `${classNames} font-thin`;

  return (
    <Markdown
      components={{
        h1: ({ node, ...props }) => <h1 className={`${classNames} text-h1 leading-h1`} {...props} />,
        h2: ({ node, ...props }) => <h2 className={`${classNames} text-h2 leading-h1`} {...props} />,
        h3: ({ node, ...props }) => <h3 className={`${classNames} text-h3 leading-h3`} {...props} />,
        h4: ({ node, ...props }) => <h4 className={`${classNames} text-h4 leading-h4`} {...props} />,
        h5: ({ node, ...props }) => <h5 className={`${classNames} text-h5 leading-8`} {...props} />,

        ul: ({ node, ...props }) => <ul className='list-disc list-inside' {...props} />,
        ol: ({ node, ...props }) => <ol className='list-decimal list-inside' {...props} />,
        li: ({ node, ...props }) => <li className={thinTextClassNames} {...props} />,

        p: ({ node, ...props }) => <p className={thinTextClassNames} {...props} />,

        blockquote: ({ node, ...props }) => <blockquote className='p-4 my-4 border-s-4 border-a75 bg-white' {...props} />,
        a: ({ node, href, ...props }) => <Link href={href || '#'} target='_blank' className='text-brand hover:text-a75' {...props} />
      }}
    >
      {markdownString}
    </Markdown>
  );
};
